import { Percent } from "@mui/icons-material";
import { Button, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";

export default function DiscountForm({value, onSubmit, onCancel}){

    const [percentOff, setPercentOff] = useState(value)

    const handleSubmit = e => {
        e.preventDefault();
        return onSubmit(percentOff)
    }

    return <form onSubmit={handleSubmit}>

        <Stack spacing={2}>

            <Typography variant='h3'>Ajouter une remise</Typography>

            <TextField
                label='Pourcentage de remise'
                type='number'
                value={percentOff}
                onChange={e => setPercentOff(parseInt(e.target.value))}
                InputProps={{
                    endAdornment: <Percent color='action'/>
                }}
                inputProps={{step: 1, min: 0, max: 100}}
                required
                size='small'
            />

            <Stack direction='row' justifyContent='flex-end' spacing={3}>

                <Button
                    color='error'
                    onClick={onCancel}
                    size='large'
                >
                    Annuler
                </Button>

                <Button
                    type='submit'
                    size='large'
                >
                    Ajouter    
                </Button>

            </Stack>


        </Stack>

    </form>
}